import { createReducer, on } from '@ngrx/store';
import { LWBPeriscopeActions } from './periscope.actions';
import { LWBPeriscopeState, lwbPeriscopeState } from './periscope.state';

export const lwbPeriscopeReducer = createReducer(
  lwbPeriscopeState,
  on(LWBPeriscopeActions.reset, (): LWBPeriscopeState => ({})),
  on(
    LWBPeriscopeActions.update,
    (state, { data }): LWBPeriscopeState => ({ ...state, ...data })
  )
);
